export function getActionCableWebSocketUrl(ticket) {
  const scheme = window.location.protocol === "https:" ? "wss" : "ws";
  const query = new URLSearchParams({ ticket }).toString();
  return `${scheme}://${window.location.host}/sockets/cable?${query}`;
}

export function extractTicketFromApiPayload(data) {
  const block = data?.response?.[0];
  if (!block || typeof block !== "object") return null;
  const ticket = block.ticket;
  return typeof ticket === "string" && ticket.length > 0 ? ticket : null;
}

export function extractTicketExpiresSeconds(data) {
  const block = data?.response?.[0];
  const n = block?.expires_in;
  return typeof n === "number" && n > 0 ? n : 30;
}

export function splitCableFrames(raw) {
  if (typeof raw !== "string" || !raw.length) return [];
  return raw.split(/\n+/).filter(Boolean);
}

export function buildSubscribeCommand(identifierString) {
  return JSON.stringify({
    command: "subscribe",
    identifier: identifierString,
  });
}

export function buildUnsubscribeCommand(identifierString) {
  return JSON.stringify({
    command: "unsubscribe",
    identifier: identifierString,
  });
}

/** Action Cable client → server frame (maps to a channel action method). */
export function buildPerformCommand(identifierString, action, payload = {}) {
  return JSON.stringify({
    command: "message",
    identifier: identifierString,
    data: JSON.stringify({ action, ...payload }),
  });
}

export function buildPongFrame(pingMessage) {
  return JSON.stringify({ type: "pong", message: pingMessage });
}
